"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var DatePickerCell_1 = require("./DatePickerCell");
var Date_1 = require("../../utils/Date");
var Localize_1 = require("../../../gen-src/Localize");
var DatePickerWidgetStyles_1 = require("../../styles/DatePickerWidgetStyles");
var DatePickerRow = /** @class */ (function (_super) {
    tslib_1.__extends(DatePickerRow, _super);
    function DatePickerRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DatePickerRow.prototype.getCell = function (index) {
        var _this = this;
        var cellDate = Date_1.getDateWithDayOffset(this.props.startDate, index);
        var isDisabled = this.props.isDateDisabled && this.props.isDateDisabled(cellDate);
        var isInCurrMonth = cellDate.getMonth() === this.props.focusedDate.getMonth();
        var isSelected = Date_1.areSameDates(cellDate, this.props.selectedDate);
        var isToday = Date_1.areSameDates(cellDate, new Date());
        var isTabbable = Date_1.areSameDates(cellDate, this.props.focusedDate);
        var isFocused = isTabbable && this.props.bodyHasFocus;
        var handleFocus = function () { return _this.props.onFocusedDateChange(cellDate); };
        var handleClick = function () {
            if (!isInCurrMonth) {
                _this.props.onFocusedDateChange(cellDate);
            }
            if (!isDisabled) {
                _this.props.onChange(cellDate);
            }
        };
        var dateLabel = Localize_1.Formatters.formatFullDate(cellDate);
        var weekNumLabel = this.props.showWeekNumbers ?
            "" + Localize_1.Messages.weekNumber({ weekNum: Date_1.getISOWeekNum(this.props.startDate).toString() })
            : '';
        var cellProps = {
            'aria-label': (dateLabel + " " + weekNumLabel).trim(),
            isDisabled: isDisabled,
            isFocused: isFocused,
            isInCurrMonth: isInCurrMonth,
            isSelected: isSelected,
            isTabbable: isTabbable,
            isToday: isToday,
            onClick: handleClick,
            onFocus: handleFocus,
        };
        return (React.createElement(DatePickerCell_1.DatePickerCell, tslib_1.__assign({ key: index }, cellProps), cellDate.getDate()));
    };
    DatePickerRow.prototype.render = function () {
        var cells = [];
        var daysOfWeekNum = 7;
        for (var i = 0; i < daysOfWeekNum; i++) {
            cells.push(this.getCell(i));
        }
        if (this.props.showWeekNumbers) {
            var currISOWeekNum = Date_1.getISOWeekNum(this.props.startDate);
            var weekNumLabel = Localize_1.Messages.weekNumber({ weekNum: currISOWeekNum.toString() });
            var weekNumCellProps = {
                style: DatePickerWidgetStyles_1.datePickerCellStyles.isoWeekNum,
                'aria-label': weekNumLabel,
                role: 'gridcell'
            };
            cells.unshift(React.createElement("div", tslib_1.__assign({}, weekNumCellProps, { key: 'iso-week' }), currISOWeekNum));
        }
        return (React.createElement("div", { style: { display: 'flex' }, role: 'row' }, cells));
    };
    return DatePickerRow;
}(React.PureComponent));
exports.DatePickerRow = DatePickerRow;
//# sourceMappingURL=DatePickerRow.js.map